import {
  AgxGlobalSearch,
  CampaignSearcherResult,
  SearchResultType,
} from '@urbanx/agx.ui-components2';
import { Pages } from 'constants/menu';
import { Link, useNavigate } from 'react-router-dom';

const PageLevelSearch = () => {
  const navigate = useNavigate();

  const getResultLink = (itemType: SearchResultType, item: CampaignSearcherResult): string => {
    switch (itemType) {
      case SearchResultType.ActiveCampaign:
      case SearchResultType.ArchivedCampaign: {
        const campaignRoute = `/${Pages.AGENCIES}/${item.agencyId}/${Pages.CAMPAIGNS}/${item.campaignId}/${Pages.CAMPAIGN_OVERVIEW}`;

        return campaignRoute;
      }

      case SearchResultType.ActiveContract:
      case SearchResultType.ArchivedContract: {
        if (!item.contractId) {
          throw new Error('A contract search result requires a contract id.');
        }

        const contractRoute = `/${Pages.AGENCIES}/${item.agencyId}/${Pages.CAMPAIGNS}/${item.campaignId}/${Pages.CONTRACTS}/${item.contractId}/${Pages.BUYERS_INFORMATION}`;

        return contractRoute;
      }

      default:
        throw new Error(`Unhandled search result type: ${itemType}`);
    }
  };

  return (
    <AgxGlobalSearch
      searchForCampaigns
      searchForContracts
      searchForArchivedCampaigns
      searchForArchivedContracts
      onItemSelected={(type, result) => navigate(getResultLink(type, result))}
      renderResultLink={({ type, result, ...props }) => (
        <Link to={getResultLink(type, result)} {...props} />
      )}
    />
  );
};

export default PageLevelSearch;
